export type AppLanguage = "en" | "kh";

export const loginText = {
  en: {
    title: "Sign in to the dashboard",
    username: "Username",
    usernamePlaceholder: "Enter your username",
    password: "Password",
    showPassword: "Show password",
    hidePassword: "Hide password",
    unlock: "Unlock dashboard",
    authError: "Incorrect username or password.",
    enterCredentials: "Please enter your username and password to continue.",
  },
  kh: {
    title: "ចូលទៅផ្ទាំងគ្រប់គ្រង",
    username: "ឈ្មោះអ្នកប្រើ",
    usernamePlaceholder: "បញ្ចូលឈ្មោះអ្នកប្រើ",
    password: "ពាក្យសម្ងាត់",
    showPassword: "បង្ហាញពាក្យសម្ងាត់",
    hidePassword: "លាក់ពាក្យសម្ងាត់",
    unlock: "បើកផ្ទាំងគ្រប់គ្រង",
    authError: "ឈ្មោះអ្នកប្រើ ឬ ពាក្យសម្ងាត់ មិនត្រឹមត្រូវ។",
    enterCredentials: "សូមបញ្ចូលឈ្មោះអ្នកប្រើ និងពាក្យសម្ងាត់ ដើម្បីបន្ត។",
  },
} as const;

export const registryText = {
  en: {
    title: "Guest Registration",
    registered: "guests registered",
    searchPlaceholder: "Search...",
    table: {
      no: "No",
      name: "Name-joiner",
      contact: "Contact",
      category: "Category",
      status: "Status",
      notes: "Notes",
      latitude: "Latitude",
      longitude: "Longitude",
      locate: "Locate",
      action: "Action",
    },
    noGuests: "No guests yet for",
    noGuestsSuffix: "Add a row to begin.",
    guestNamePlaceholder: "Guest name",
    guestNameRequired: "Name is required.",
    contactPlaceholder: "Phone / Facebook / Telegram",
    notesPlaceholder: "Notes",
    locateBtn: "Locate",
    upload: "Upload",
    batchesSaved: "upload batches saved",
    batchSaved: "upload batch saved",
    uploadHint: "Click Upload to save the current table records.",
    uploadedNoRecords: "No uploaded records yet for",
    uploadedRows: "guest rows",
    importGuests: "Import guests",
    downloadTemplateSample: "Download template sample",
    uploadData: "Upload data",
    downloading: "Downloading...",
    loadingUploadedRecords: "Loading uploaded records...",
    uploading: "Uploading...",
    uploadGuestExcelTitle: "Upload Guest Excel",
    guestGroupLabel: "Guest group",
    brideGroup: "Bride",
    groomGroup: "Groom",
    excelFileLabel: "Excel file",
    chooseFile: "Choose file",
    noFileSelected: "No file selected",
    cancel: "Cancel",
    sessionExpiredSignInAgain: "Session expired. Please sign in again.",
    chooseExcelFileFirst: "Please choose an Excel file first.",
    unableDownloadTemplate: "Unable to download template.",
    uploadFailed: "Upload failed.",
    uploadSuccessSummary: "Uploaded successfully: {created} created, {failed} failed.",
    sameNameButton: "Same Name",
    uploadedFilterTabs: {
      all: "All",
      groom: "Groom guests",
      bride: "Bride guests",
    },
  },
  kh: {
    title: "ចុះឈ្មោះភ្ញៀវ",
    registered: "ភ្ញៀវបានចុះបញ្ជី",
    searchPlaceholder: "ស្វែងរក...",
    table: {
      no: "ល.រ",
      name: "ឈ្មោះភ្ញៀវ",
      contact: "ទំនាក់ទំនង",
      category: "ប្រភេទ",
      status: "ស្ថានភាព",
      notes: "កំណត់ចំណាំ",
      latitude: "រយៈទទឹង",
      longitude: "រយៈបណ្តោយ",
      locate: "កំណត់ទីតាំង",
      action: "សកម្មភាព",
    },
    noGuests: "មិនទាន់មានភ្ញៀវសម្រាប់",
    noGuestsSuffix: "បន្ថែមជួរដើម្បីចាប់ផ្តើម។",
    guestNamePlaceholder: "ឈ្មោះភ្ញៀវ",
    guestNameRequired: "សូមបញ្ចូលឈ្មោះ។",
    contactPlaceholder: "ទូរស័ព្ទ / ហ្វេសប៊ុក / តេឡេក្រាម",
    notesPlaceholder: "កំណត់ចំណាំ",
    locateBtn: "កំណត់ទីតាំង",
    upload: "បញ្ចូល",
    batchesSaved: "ដងបានបញ្ចូលរក្សាទុក",
    batchSaved: "ដងបានបញ្ចូលរក្សាទុក",
    uploadHint: "ចុច បញ្ចូល ដើម្បីរក្សាទុកទិន្នន័យតារាងបច្ចុប្បន្ន។",
    uploadedNoRecords: "មិនទាន់មានកំណត់ត្រាបានបញ្ចូលសម្រាប់",
    uploadedRows: "ជួរភ្ញៀវ",
    importGuests: "នាំចូលភ្ញៀវ",
    downloadTemplateSample: "ទាញយកគំរូតារាង",
    uploadData: "ផ្ទុកទិន្នន័យ",
    downloading: "កំពុងទាញយក...",
    loadingUploadedRecords: "កំពុងផ្ទុកកំណត់ត្រាដែលបានបញ្ចូល...",
    uploading: "កំពុងបញ្ចូល...",
    uploadGuestExcelTitle: "ផ្ទុកឯកសារ Excel ភ្ញៀវ",
    guestGroupLabel: "ក្រុមភ្ញៀវ",
    brideGroup: "កូនស្រី",
    groomGroup: "កូនប្រុស",
    excelFileLabel: "ឯកសារ Excel",
    chooseFile: "ជ្រើសឯកសារ",
    noFileSelected: "មិនទាន់ជ្រើសឯកសារ",
    cancel: "បោះបង់",
    sessionExpiredSignInAgain: "សម័យបានផុតកំណត់។ សូមចូលប្រើម្តងទៀត។",
    chooseExcelFileFirst: "សូមជ្រើសឯកសារ Excel ជាមុនសិន។",
    unableDownloadTemplate: "មិនអាចទាញយកគំរូតារាងបានទេ។",
    uploadFailed: "ការផ្ទុកបានបរាជ័យ។",
    uploadSuccessSummary: "បានផ្ទុកដោយជោគជ័យ៖ បង្កើតបាន {created} បរាជ័យ {failed}។",
    sameNameButton: "ឈ្មោះដូចគ្នា",
    uploadedFilterTabs: {
      all: "ទាំងអស់",
      groom: "ភ្ញៀវកូនប្រុស",
      bride: "ភ្ញៀវកូនស្រី",
    },
  },
} as const;

export const guestsText = {
  en: {
    tab: "Attendance Guest Data",
    title: "Guests",
    countSuffix: "guests",
    searchPlaceholder: "Search guests...",
    searchInputLabel: "Search Guest",
    sameNameButton: "Same Name",
    all: "All",
    estimateLabel: "Estimate",
    groupFilter: {
      all: "All",
      bride: "Bride guests",
      groom: "Groom guests",
    },
    status: {
      Joining: "Joining",
      Maybe: "Maybe",
      "Not yet": "Not yet",
    },
    doneFilter: {
      All: "All",
      Pending: "Pending",
      Done: "Done",
    },
    invitedFilter: {
      All: "All",
      Invited: "Invited",
      "Not invited": "Not invited",
    },
    giftFilter: {
      All: "All",
      Gift: "Gift",
      "No gift": "No gift",
    },
    table: {
      no: "No",
      name: "Name",
      contact: "Contact",
      category: "Category",
      status: "Status",
      group: "Group",
      latitude: "Latitude",
      longitude: "Longitude",
      gift: "Gift",
      invite: "Invite",
      action: "Action",
    },
    noGuests: "No guests found.",
    doneBtn: "Done",
    markDoneBtn: "Waiting",
    inviteBtn: "Invite",
    invitedBtn: "Invited",
    totalUsd: "Total USD",
    totalRiel: "Total Riel",
    viewGuests: "Guests",
    noStatusGuests: "No guests found for this status.",
    giftModalTitle: "Gift",
    giftModalHint: "Enter the gift amount for this guest.",
    cancel: "Cancel",
    save: "Save",
  },
  kh: {
    tab: "ទិន្នន័យភ្ញៀវចូលរួម",
    title: "ភ្ញៀវ",
    countSuffix: "នាក់",
    searchPlaceholder: "ស្វែងរកភ្ញៀវ...",
    searchInputLabel: "ស្វែងរកភ្ញៀវ",
    sameNameButton: "ឈ្មោះដូចគ្នា",
    all: "ទាំងអស់",
    estimateLabel: "ប៉ាន់ស្មាន",
    groupFilter: {
      all: "ទាំងអស់",
      bride: "ភ្ញៀវកូនស្រី",
      groom: "ភ្ញៀវកូនប្រុស",
    },
    status: {
      Joining: "ចូលរួម",
      Maybe: "អាច",
      "Not yet": "មិនទាន់",
    },
    doneFilter: {
      All: "ទាំងអស់",
      Pending: "មិនទាន់រួច",
      Done: "រួចរាល់",
    },
    invitedFilter: {
      All: "ទាំងអស់",
      Invited: "បានអញ្ជើញ",
      "Not invited": "មិនទាន់អញ្ជើញ",
    },
    giftFilter: {
      All: "ទាំងអស់",
      Gift: "មានចំណងដៃ",
      "No gift": "គ្មានចំណងដៃ",
    },
    table: {
      no: "ល.រ",
      name: "ឈ្មោះ",
      contact: "ទំនាក់ទំនង",
      category: "ប្រភេទ",
      status: "ស្ថានភាព",
      group: "ក្រុម",
      latitude: "រយៈទទឹង",
      longitude: "រយៈបណ្តោយ",
      gift: "ចំណងដៃ",
      invite: "អញ្ជើញ",
      action: "សកម្មភាព",
    },
    noGuests: "មិនមានភ្ញៀវត្រូវគ្នា។",
    doneBtn: "រួចរាល់",
    markDoneBtn: "រង់ចាំ",
    inviteBtn: "អញ្ជើញ",
    invitedBtn: "បានអញ្ជើញ",
    totalUsd: "សរុប USD",
    totalRiel: "សរុប រៀល",
    viewGuests: "ភ្ញៀវ",
    noStatusGuests: "មិនមានភ្ញៀវសម្រាប់ស្ថានភាពនេះ។",
    giftModalTitle: "ចំណងដៃ",
    giftModalHint: "សូមបញ្ចូលចំនួនចំណងដៃសម្រាប់ភ្ញៀវនេះ។",
    cancel: "បោះបង់",
    save: "រក្សាទុក",
  },
} as const;

export const budgetText = {
  en: {
    tab: "Budget Plan",
    leftTitle: "Spending & budget",
    leftHint: "Track plan amount and current amount for each item.",
    totals: "Totals",
    budgetCap: "Budget cap",
    planAmount: "Plan amount",
    planBalanceLabel: "Plan balance",
    currentAmount: "Current amount",
    leftAmount: "Left amount",
    spendingItem: "Spending item",
    spendingItemPlaceholder: "Photography, catering, decor...",
    planPlaceholder: "0",
    currentPlaceholder: "0",
    notes: "Notes",
    notesPlaceholder: "Deposit, pending, paid...",
    addSpending: "Add spending",
    updateSpending: "Update spending",
    trackerTitle: "Budget tracker",
    lineItemsTracked: "line items tracked",
    overview: "Overview",
    planMinusCurrentLabel: "Plan minus current",
    table: {
      item: "Item",
      plan: "Plan",
      current: "Current",
      left: "Left",
      notes: "Notes",
      action: "Action",
      totalsLabel: "Totals",
    },
    noItems: "No spending items yet. Add one on the left.",
    withinBudget: "Within budget",
    overBudget: "Over budget",
    totalUsd: "Total USD",
    totalRiel: "Total Riel",
    editAmountsTitle: "Edit Amounts",
    editAmountsHint: "Update plan amount and current amount.",
    cancel: "Cancel",
    save: "Save",
    edit: "Edit",
    delete: "Delete",
    inputAmountOnly: "Input amount only.",
    currentAmountLimitWarning: "Current amount cannot exceed the total spent {limit}.",
  },
  kh: {
    tab: "ថវិកាគ្រោងទុក",
    leftTitle: "ចំណាយ និង ថវិកា",
    leftHint: "តាមដានចំនួនគម្រោង និង ចំនួនបច្ចុប្បន្នសម្រាប់មុខចំណាយនីមួយៗ",
    totals: "សរុប",
    budgetCap: "កម្រិតថវិកា",
    planAmount: "ចំនួនគម្រោង",
    planBalanceLabel: "សមតុល្យផែនការ",
    currentAmount: "ចំនួនបច្ចុប្បន្ន",
    leftAmount: "ចំនួននៅសល់",
    spendingItem: "មុខចំណាយ",
    spendingItemPlaceholder: "ថតរូប, ម្ហូបអាហារ, តុបតែង...",
    planPlaceholder: "0",
    currentPlaceholder: "0",
    notes: "កំណត់ចំណាំ",
    notesPlaceholder: "កក់មុន, កំពុងរង់ចាំ, បានបង់...",
    addSpending: "បន្ថែមចំណាយ",
    updateSpending: "ធ្វើបច្ចុប្បន្នភាពចំណាយ",
    trackerTitle: "តារាងថវិកា",
    lineItemsTracked: "មុខចំណាយបានតាមដាន",
    overview: "សង្ខេប",
    planMinusCurrentLabel: "ផែនការកាត់បន្ថយបច្ចុប្បន្ន",
    table: {
      item: "មុខចំណាយ",
      plan: "គម្រោង",
      current: "បច្ចុប្បន្ន",
      left: "នៅសល់",
      notes: "កំណត់ចំណាំ",
      action: "សកម្មភាព",
      totalsLabel: "សរុប",
    },
    noItems: "មិនទាន់មានមុខចំណាយទេ។ សូមបន្ថែមនៅផ្នែកខាងឆ្វេង។",
    withinBudget: "ក្នុងថវិកា",
    overBudget: "លើសថវិកា",
    totalUsd: "សរុប USD",
    totalRiel: "សរុប រៀល",
    editAmountsTitle: "កែប្រែចំនួន",
    editAmountsHint: "ធ្វើបច្ចុប្បន្នភាពចំនួនគម្រោង និង ចំនួនបច្ចុប្បន្ន។",
    cancel: "បោះបង់",
    save: "រក្សាទុក",
    edit: "កែប្រែ",
    delete: "លុប",
    inputAmountOnly: "បញ្ចូលបានតែចំនួនទឹកប្រាក់ប៉ុណ្ណោះ។",
    currentAmountLimitWarning: "ចំនួនបច្ចុប្បន្នមិនអាចលើសចំនួនចំណាយសរុប {limit}។",
  },
} as const;

export const systemText = {
  en: {
    unableReachLoginApi: "Unable to reach login API. Please check server connection.",
    signInAgainUpload: "Please sign in again before uploading.",
    signInAgainDeleteRecords: "Please sign in again before deleting records.",
    signInAgainLoadRecords: "Please sign in again before loading uploaded records.",
    signInAgainSearchRecords: "Please sign in again before searching records.",
    unableUploadRegistryDrafts: "Unable to upload registry drafts.",
    unableDeleteUploadedRecord: "Unable to delete uploaded record.",
    unableLoadUploadedRegistryRecords: "Unable to load uploaded registry records.",
    unableSearchRegistryRecords: "Unable to search registry records.",
    failedUpdate: "Failed update.",
    updatedSuccessfully: "Updated successfully.",
    deletedSuccessfully: "Deleted successfully.",
    textNotAllowedAmountOnly: "Text is not allowed. Please enter numbers only.",
    selectGuestBeforeLocation: "Select a guest before setting location.",
    geolocationNotSupported: "Geolocation is not supported in this browser.",
    locationRequiresSecureContext: "Location requires a secure context (HTTPS or localhost).",
    permissionDeniedLocation: "Permission denied for location access.",
    locationUnavailableTryAgain: "Location unavailable. Try again.",
    locationRequestTimedOut: "Location request timed out.",
    unableAccessCurrentLocation: "Unable to access current location.",
    confirmSignOutTitle: "Confirm sign out",
    confirmSignOutMessage: "Are you sure you want to sign out?",
    confirmDeleteTitle: "Confirm delete",
    confirmDeleteUploadedMessage: "Are you sure you want to delete this uploaded record?",
    confirmDeleteBudgetMessage: "Are you sure to delete this budget item?",
    deleting: "Deleting...",
    delete: "Delete",
    cancel: "Cancel",
    signOut: "Sign out",
    success: "Success",
    ok: "OK",
    pickLocation: "Pick location",
    clickMapSetLocation: "Click the map to set latitude and longitude.",
    useCurrent: "Use current",
    close: "Close",
    closeGuestList: "Close guest list",
    clearAmount: "Clear amount",
  },
  kh: {
    unableReachLoginApi: "មិនអាចភ្ជាប់ទៅ API ចូលប្រើបានទេ។ សូមពិនិត្យការតភ្ជាប់ម៉ាស៊ីនមេ។",
    signInAgainUpload: "សូមចូលប្រើម្ដងទៀត មុនពេលបញ្ចូលទិន្នន័យ។",
    signInAgainDeleteRecords: "សូមចូលប្រើម្ដងទៀត មុនពេលលុបកំណត់ត្រា។",
    signInAgainLoadRecords: "សូមចូលប្រើម្ដងទៀត មុនពេលផ្ទុកកំណត់ត្រាដែលបានបញ្ចូល។",
    signInAgainSearchRecords: "សូមចូលប្រើម្ដងទៀត មុនពេលស្វែងរកកំណត់ត្រា។",
    unableUploadRegistryDrafts: "មិនអាចបញ្ចូលសេចក្តីព្រាងបញ្ជីភ្ញៀវបានទេ។",
    unableDeleteUploadedRecord: "មិនអាចលុបកំណត់ត្រាដែលបានបញ្ចូលបានទេ។",
    unableLoadUploadedRegistryRecords: "មិនអាចផ្ទុកកំណត់ត្រាបញ្ជីភ្ញៀវដែលបានបញ្ចូលបានទេ។",
    unableSearchRegistryRecords: "មិនអាចស្វែងរកកំណត់ត្រាបញ្ជីភ្ញៀវបានទេ។",
    failedUpdate: "ការធ្វើបច្ចុប្បន្នភាពបរាជ័យ។",
    updatedSuccessfully: "បានធ្វើបច្ចុប្បន្នភាពដោយជោគជ័យ។",
    deletedSuccessfully: "បានលុបដោយជោគជ័យ។",
    textNotAllowedAmountOnly: "មិនអនុញ្ញាតអក្សរ។ សូមបញ្ចូលបានតែលេខប៉ុណ្ណោះ។",
    selectGuestBeforeLocation: "សូមជ្រើសរើសភ្ញៀវ មុនពេលកំណត់ទីតាំង។",
    geolocationNotSupported: "កម្មវិធីរុករកនេះមិនគាំទ្រ Geolocation ទេ។",
    locationRequiresSecureContext: "ការប្រើទីតាំងត្រូវការ secure context (HTTPS ឬ localhost)។",
    permissionDeniedLocation: "បានបដិសេធសិទ្ធិប្រើទីតាំង។",
    locationUnavailableTryAgain: "ទីតាំងមិនអាចប្រើបាន។ សូមព្យាយាមម្តងទៀត។",
    locationRequestTimedOut: "ការស្នើសុំទីតាំងអស់ពេលកំណត់។",
    unableAccessCurrentLocation: "មិនអាចចូលប្រើទីតាំងបច្ចុប្បន្នបានទេ។",
    confirmSignOutTitle: "បញ្ជាក់ការចាកចេញ",
    confirmSignOutMessage: "តើអ្នកប្រាកដថាចង់ចាកចេញមែនទេ?",
    confirmDeleteTitle: "បញ្ជាក់ការលុប",
    confirmDeleteUploadedMessage: "តើអ្នកប្រាកដថាចង់លុបកំណត់ត្រាដែលបានបញ្ចូលមែនទេ?",
    confirmDeleteBudgetMessage: "តើអ្នកប្រាកដថាចង់លុបមុខចំណាយនេះមែនទេ?",
    deleting: "កំពុងលុប...",
    delete: "លុប",
    cancel: "បោះបង់",
    signOut: "ចាកចេញ",
    success: "ជោគជ័យ",
    ok: "យល់ព្រម",
    pickLocation: "ជ្រើសរើសទីតាំង",
    clickMapSetLocation: "ចុចលើផែនទីដើម្បីកំណត់រយៈទទឹង និង រយៈបណ្តោយ។",
    useCurrent: "ប្រើទីតាំងបច្ចុប្បន្ន",
    close: "បិទ",
    closeGuestList: "បិទបញ្ជីភ្ញៀវ",
    clearAmount: "លុបតម្លៃ",
  },
} as const;
